export const faqData = [
  {
    title: 'How does the Sunbit card work?',
    text: `At the end of every monthly cycle, we calculate your minimum payment due based on your balance (which reflects new purchases, credits, and payments) and interest that is expected to accrue over 12 months (like a 12-month payment plan). Generally, if you don’t make any new purchases or receive credits or refunds during a billing cycle and if the Prime Rate does not fluctuate, you will pay off your balance in 12 months.`,
    open: true,
  },
  {
    title: 'How is the Sunbit card different from credit cards?',
    text: `As opposed to traditional credit cards, with the Sunbit Card, your monthly balance is split into a 12-month payment plan (which you can always pay off sooner, and pay less interest by doing so).`,
  },
  {
    title: 'What do I need to have ready in order to apply?',
    text: `You’re already a Sunbit customer, so all you’ll need to provide is the personalized Verification Code from the application page, the last 4 digits of your Social Security number, with your net monthly income, your housing expenses, and payment method information.`,
  },
  {
    title: 'How does applying for the card impact my credit score?',
    text: `Completing the application will not impact your credit score but all account openings and payment performance are reported to a major credit bureau.`,
  },
  {
    title: `How soon after I'm approved can I use the Sunbit Card?`,
    text: `You can use it as soon as you receive and activate the card. It should arrive in the mail within 7-12 business days. `,
  },
  {
    title: 'Can I apply over the phone?',
    text: `No, the application needs to be done online.`,
  },
  {
    title: 'Why do you need my personal information?',
    text: `We need this information to confirm your identity.`,
  },
  {
    title: `How long does it take for me to find out if I’m approved?`,
    text: `You’ll find out as soon as you submit your application online.`,
  },
  {
    title: 'What will my credit line be?',
    text: `If you’re approved, we’ll let you know what your credit line is right away.`,
  },
  {
    title: 'Can I increase my credit line?',
    text: `We don’t currently accept applications for credit line increases.`,
  },
  {
    title: 'When will I receive my Sunbit card?',
    text: `You should get it in the mail within 7 to 12 business days after you're approved.`,
  },
  {
    title: 'Can I add someone to my account?',
    text: `No -- your Sunbit Card is assigned to you, and for your personal use only.`,
  },
  {
    title: 'Is there an annual fee?',
    text: `No, there is no annual fee.`,
  },
  {
    title: 'How is the minimum payment due calculated?',
    text: `Generally, we calculate your minimum payment due so that, if you make all payments on time each month and make no further purchases, your payments will be mostly equal and you will pay off your outstanding balance and accrued interest in 12 months. If you make new purchases, then we will add those new purchases to your balance, add the interest that is expected to accrue over 12 months, and then split that amount into a 12 to get your new minimum payment due. If you make a return, then we will credit that amount and your subsequent minimum payments due will generally be reduced.`,
  },
  {
    title: 'Will my interest rate change or fluctuate?',
    text: `The interest rate can vary slightly with the Prime Rate so long as you're carrying a balance.`,
  },
  {
    title: 'Is there a late fee?',
    text: `Yes, if you are more than 10 days late on a payment, there is a late fee of $19.`,
  },
  {
    title: 'How much interest will I pay?',
    text: `If you pay your entire balance on or before the due date you will not be charged any interest. Otherwise, you will be charged interest as it normally accrues based on your average daily balance.`,
  },
  {
    title: 'How will I receive my statements?',
    text: `Your statements will be sent electronically to the email address on file. If you don’t see the email in your inbox please check your promotion/social/spam/junk folder. You can request a paper statement in lieu of an electronic one by calling (855-678-6248) or emailing us (support@sunbit.com).`,
  },
  {
    title: 'Where can I use the Sunbit Card?',
    text: `The Sunbit Card can be used anywhere Visa® is accepted, in-store or online.`,
  },
  {
    title: 'How can I contact you?',
    text: `You can call us at 855-678-6248 or email us at support@sunbit.com.  We will be happy to assist you with any questions.`,
  },
];
